import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import { useMastersStore } from "../../data/mastersStore";
import { Sidebar } from "./Sidebar";

// Top-level chrome: fixed left sidebar + scrollable main area. El AppShell
// solo se monta tras pasar ProtectedRoute, así que cuando estos efectos
// corren ya hay sesión. La telemetría en vivo de Última Milla ahora se
// obtiene por polling REST (useLiveFleet), no por el WebSocket viejo.
export function AppShell() {
  const currentUser = useAuth().currentUser;
  const hydrate = useMastersStore((s) => s.hydrate);

  // Hidratar maestros desde la REST API tras el login. Si la API no
  // responde, el store conserva los datos del seed (graceful degradation).
  useEffect(() => {
    if (currentUser) {
      hydrate({ targetUserID: currentUser.id });
    }
  }, [currentUser, hydrate]);

  return (
    <div className="h-full flex bg-page">
      <Sidebar />
      <main className="flex-1 min-w-0 min-h-0 flex flex-col">
        <Outlet />
      </main>
    </div>
  );
}
